import VapSecondaryAction from './VapSecondaryAction';

export default VapSecondaryAction;
